import { alpha, makeStyles } from '@rbx/ui';

const bumperWidth = 36;
const tilePaddingWidth = 16;

const useBaseCarouselStyles = makeStyles()((theme) => ({
  wrapper: {
    position: 'relative',
  },
  carousel: {
    display: 'flex',
    flexWrap: 'nowrap',
    gap: tilePaddingWidth,
    width: '100%',
    overflowX: 'scroll',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar ': {
      display: 'none',
    },

    '& > * ': {
      flexShrink: 0,
    },

    '& > *:last-child': {
      marginRight: 0,
    },
  },
  leftBumper: {
    zIndex: theme.zIndex.speedDial,
    position: 'absolute',
    height: '100%',
    top: 0,
    left: -12,
    backgroundImage: `linear-gradient(to right, ${alpha(theme.palette.surface[0], 255)}, ${alpha(
      theme.palette.surface[0],
      0,
    )})`,
  },
  rightBumper: {
    zIndex: theme.zIndex.speedDial,
    position: 'absolute',
    height: '100%',
    top: 0,
    right: -24,
    backgroundImage: `linear-gradient(to left, ${alpha(theme.palette.surface[0], 255)}, ${alpha(
      theme.palette.surface[0],
      0,
    )})`,
  },
  bumperWrapper: {
    display: 'flex',
    width: bumperWidth,
    height: '100%',
    justifyContent: 'center',
  },
  iconButton: {
    opacity: 0,
    alignSelf: 'center',
    transition: '400ms',
  },
  hoverIconButton: {
    opacity: 1,
  },
}));

export default useBaseCarouselStyles;
